import React, { useEffect, useState } from 'react';
import { pageService } from 'services/page.service';

const useTerms = () => {
    const [termsData, setTermsData] = useState({});

    const handleApi = async () => {
        try {
            const response = await pageService.termsPage()
            setTermsData(response.data.data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        handleApi();
    }, []);

    return { termsData };
}

export default useTerms;